export interface MonthSelectProps {
    minDate: Date;
    maxDate: Date;
    selectedDate: Date;
    ariaLabel?: string;
    id?: string;
    onChange: (e: React.ChangeEvent<HTMLSelectElement>, key: string) => void;
}

const YearSelect = (props: MonthSelectProps) => {
    const { selectedDate, minDate, maxDate, ariaLabel, id, onChange } = props;

    // get years between min and max date
    const years = [];

    for (let year = minDate.getFullYear(); year <= maxDate.getFullYear(); year++) {
        years.push(year);
    }

    return (
        <span className="date-select">
            <label htmlFor={id} className="sr-only">
                {ariaLabel}
            </label>
            <select
                className="start-date-year-input"
                onChange={(e) => onChange(e, 'year')}
                aria-label={ariaLabel || ''}
                id={id || ''}
                value={selectedDate.getFullYear()}
            >
                {years?.map((y: number, i: number) => (
                    <option key={i} value={y}>
                        {y}
                    </option>
                ))}
            </select>
        </span>
    );
};

export default YearSelect;
